<template>
  <div class="dialog">
    <el-dialog
      :visible.sync="show"
      :width="width"
      :show-close="false"
      :append-to-body="true"
      :close-on-click-modal="closeOnClickModal"
      :custom-class="customClass ? `re-dialog ${customClass}` : 're-dialog'"
    >
      <div slot="title" class="fr ac jsb">
        <div>{{ title }}</div>
        <i class="el-icon-close white fz30 cursor" @click="show = false"></i>
      </div>
      <slot></slot>
      <template slot="footer">
        <slot name="footer"></slot>
      </template>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    closeOnClickModal: {
      type: Boolean,
      default: false,
    },
    visible: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
    },
    width: {
      type: String,
      default: "40%",
    },
    // 透传给 el-dialog 的 custom-class：弹窗因 append-to-body 被挂到 body 下，
    // 使用方的嵌套样式选择不到它，需要通过该类名定位弹窗本体来写样式
    customClass: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      show: true,
    };
  },
  computed: {},
  created() {
    this.show = this.$props.visible;
  },
  mounted() {},
  watch: {
    visible(n) {
      this.show = n;
    },
    show(n) {
      this.$emit("update:visible", n);
    },
  },
  methods: {},
  components: {},
};
</script>

<style lang="scss">
// el-dialog 开了 append-to-body，弹窗实际挂在 body 下，
// 不在 .dialog 内部，所以这里通过 custom-class 加上的 .re-dialog 来定位
.re-dialog {
  .el-dialog__header {
    padding: 0 15px;
    background-color: #458ef6;
    color: white;
    width: 100%;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .fr.ac.jsb {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
  }

  .el-dialog__body {
    padding: 0;
    max-height: 600px;
    overflow-y: scroll;
    overflow-x: hidden;
  }

  .el-dialog__footer {
    padding: 10px;
    border-top: 1px solid #e5e5e5;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/dialog.vue